import { MARQUEE_ITEMS } from "../data/content";

function Strip({ hidden }) {
  return (
    <div aria-hidden={hidden || undefined} className="flex w-max shrink-0 items-center">
      {MARQUEE_ITEMS.map((item) => (
        <span key={item} className="flex items-center">
          <span className="px-8 font-script text-3xl font-bold text-[#F3E096] sm:text-4xl">{item}</span>
          <span className="inline-block h-2 w-2 rotate-45 bg-[#D4AF37]/80" />
        </span>
      ))}
    </div>
  );
}

export default function Marquee() {
  return (
    <div
      className="relative overflow-hidden bg-[#0D4B56] py-5"
      data-testid="hope-marquee"
    >
      <div className="flex w-max animate-marquee will-change-transform">
        <Strip />
        <Strip hidden />
      </div>
    </div>
  );
}
